var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDropdown)?_c('gl-disclosure-dropdown',{attrs:{"items":_vm.items,"toggle-text":_vm.text,"loading":_vm.loading,"icon":"download","size":"small","placement":"bottom-end"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }